<template>
  <div>
    <div v-if="groundFloors.length === 0 && actionType === 'view'" style="margin-top: 40px">
      <span>{{ $t("NoVerticalPlanning") }}</span>
    </div>

    <v-btn v-if="groundFloors.length === 0 && undergroundFloors.length === 0 && !dialogIsOpen && actionType !== 'view'" @click="dialogIsOpen = true" style="margin-top: 40px" class="structure-button">
      {{ $t("DefineBuildingStructure") }}
    </v-btn>

    <div
      v-show="groundFloors.length > 0 || undergroundFloors.length > 0"
      class="form tab-content"
      style="flex-wrap: nowrap;"
      :key="buildingKey"
    >
      <building
        class="building"
        :ground-floors="groundFloors"
        :underground-floors="undergroundFloors"
        :columns="columns"
        :selected-floorbox="selectedFloorbox"
        :selected-object="selectedObject"
        :action-type="actionType"
        @add-column="addColumn"
        @add-ground-floor="addFloor(groundFloors.length, 'ground')"
        @add-underground-floor="addFloor(-1 - undergroundFloors.length, 'underground')"
        @select-column="selectColumn($event)"
        @select-floorbox="selectFloorbox($event.floorbox)"
        @swap-floorbox="swapFloorbox($event.columnIndex, $event.floorboxIndex)"
        @select-floor="selectFloor($event.floorIndex, $event.floorType)"
        @select-fraction="selectFraction($event.floorIndex, $event.floorType, $event.fractionIndex)"
        @connect-all-fractions="connectAllFractions($event.floorIndex, $event.floorType)"
      />

      <div
        class="vertical-splitter"
        :style="{ height: dividerHeight + 'px' }"
      />
      <div class="d-flex flex-column">
        <vertical-structure-buttons
          v-show="!selectedObject.data"
          :columns="columns.length"
          :underground-floors="undergroundFloors.length"
          :ground-floors="groundFloors.length"
          @add-column="addColumn"
          @delete-column="deleteColumn"
          @add-underground-floor="addFloor"
          @add-ground-floor="addFloor"
          @delete-floor="deleteFloor"
        />

        <technical-locals-table
          v-show="!selectedObject.data"
          :tecnical-table-is-open="tecnicalTableIsOpen"
          :action-type="actionType"
          :technical-locals="technicalLocals"
          @open-tecnical-local-form="openTecnicalLocalForm"
          @open-edit-tecnical-local="openEditTecnicalLocal"
          @delete-tecnical-local="deleteTecnicalLocal"
          @open-and-close-tecnical-local-table="tecnicalTableIsOpen = !tecnicalTableIsOpen"
        />

        <fractions-table 
          v-if="selectedObject.type !== 'Column'"
          :ground-floors="groundFloors"
          :underground-floors="undergroundFloors"
          :fractions="getAllFractions()"
          :fractions-table-is-open="fractionsTableIsOpen"
          :selected-object="selectedObject"
          :cableTypeFiveOptions="cableTypeFiveOptions"
          @select-fraction="selectTableItem($event.floorIndex, $event.floorType, $event.fractionIndex)"
          @create-fraction="createFraction($event)"
          @save-fraction="saveFraction($event.data)"
          @delete-fraction="deleteFloorFraction($event)"
          @open-and-close-fractions-table="fractionsTableIsOpen = !fractionsTableIsOpen"
        />
        <floorboxes-table
          v-show="selectedObject.data"
          :selected-object="selectedObject"
          :floorbox-colors="availableFloorboxColors"
          :action-type="actionType"
          :ground-floors="groundFloors"
          :underground-floors="undergroundFloors"
          :columns="columns"
          :technical-locals="technicalLocals"
          :floorboxs="getFloorboxs()"
          :cableTypeSixOptions="cableTypeSixOptions"
          :cableTypeFiveOptions="cableTypeFiveOptions"
          style="min-width: 25%"
          @delete-column="deleteColumn($event.columnIndex)"
          @delete-floor="deleteFloor($event.floorIndex)"
          @delete-floorbox="deleteFloorbox($event.columnUuid, $event.floorboxLabel)"
          @create-floorbox="createFloorbox($event)"
          @save-floorbox="saveFloorbox($event.data, $event.index)"
        />
      </div>
    </div>

    <building-structure-dialog
      :dialog-is-open="dialogIsOpen"
      @close-dialog="closeDialog"
      @preview-building="previewBuilding($event)"
    />
    <technical-local-form 
      v-if="tecnicalLocalFormIsOpen"
      :dialog-is-open="tecnicalLocalFormIsOpen"
      :item-to-edit="itemToEdit"
      @add-tecnical-local="addTecnicalLocal"
      @edit-tecnical-local="editTecnicalLocal"
      @close-tecnical-local-form="closeTecnicalLocalForm"
    />

  </div>
</template>

<script>
import Building from "./Building";
import FloorboxesTable from "./FloorboxesTable.vue";
import VerticalStructureButtons from "./VerticalStructureButtons.vue";
import TechnicalLocalsTable from "./TechnicalLocalsTable.vue";
import FractionsTable from "./FractionsTable.vue";
import BuildingStructureDialog from "./BuildingStructureDialog.vue";
import { mapActions } from 'vuex';
import { v4 as uuidv4 } from 'uuid';
import TechnicalLocalForm from "./TechnicalLocalForm.vue";
import { verticalMixin } from "@/mixins/verticalMixin.js";
export default {
  name: "VerticalPlanning",

  components: {
    Building,
    FloorboxesTable,
    BuildingStructureDialog,
    VerticalStructureButtons,
    TechnicalLocalsTable,
    TechnicalLocalForm,
    FractionsTable
  },

  mixins: [verticalMixin],

  props: {
    actionType: {
      type: String
    },
    groundFloorsProp: {
      type: Array
    },
    undergroundFloorsProp: {
      type: Array
    },
    columnsProp: {
      type: Array
    },
    technicalLocalsProp: {
      type: Array
    },
  },

  data() {
    return {
      dialogIsOpen: false,
      tecnicalLocalFormIsOpen:false,
      tecnicalTableIsOpen: false,
      fractionsTableIsOpen: false,
      showTable: false,
      groundFloors: [],
      undergroundFloors: [],
      columns: [],
      technicalLocals:[],
      fractionsPerFloor: null,
      itemToEdit: null,
      selectedFloorbox: {
        id: null,
        color: null,
        label: null
      },

      selectedObject: {
        data: null,
        type: null,
        id: null,
        index: null,
        uuid: null
      },

      buildingKey: 0,

      floorboxColors: [],
      cableTypeSixOptions: [],
      cableTypeFiveOptions: []
    }
  },

  /** When the component is mounted the floorbox colours are loaded and is made a copy of the data to send */
  mounted() {
    this.getFloorboxColours();
    this.getCableTypeFiveOptions();
    this.getCableTypeSixOptions();
    this.groundFloors = structuredClone(this.groundFloorsProp);
    this.undergroundFloors = structuredClone(this.undergroundFloorsProp);
    this.columns = structuredClone(this.columnsProp);
    this.technicalLocals = structuredClone(this.technicalLocalsProp);
    if (this.groundFloorsProp.length === 0 && this.actionType !== 'view') {
      this.dialogIsOpen = true;
    }
  },
  watch:{
    groundFloors(){
      this.getAllFractions();
    },
    undergroundFloors(){
      this.getAllFractions();
    }
  },
  computed: {
    /** Returns the available floorbox colors, removing all the used colours from the colours lisst */
    availableFloorboxColors() {
      let usedColors = [];
      this.columns.forEach(column => {
        let colors = column.floorboxes.map(floorbox => floorbox.color.toUpperCase());
        usedColors = usedColors.concat(colors)
      });
      return this.floorboxColors.filter(color => !usedColors.includes(color.id))
    },

    /** Indicates the height of the divider of the building and the table */
    dividerHeight() {
      let floorHeight = 36;
      let groundFloors = this.groundFloors.length > 7 ? 7 : this.groundFloors.length ;
      let undergroundFloors = this.undergroundFloors.length > 3 ? 3 : this.undergroundFloors.length;
      let editButtons = this.actionType !== 'view' ? 1 : 0;
      return (groundFloors + undergroundFloors + editButtons + 2) * floorHeight;
    }
  },
  methods: {
    ...mapActions(["GET_LIST", "fetchStockMaterialsList"]),
    async getCableTypeFiveOptions(){
      const cablesTypeFive = [];
      const materials = await this.fetchStockMaterialsList(
        {
          workspace_uuid: this.$store.getters.workspace.uuid,
          material_family_id: "ca",
          network_level_id: "5",
          append: "family_specific_fields"
        }
      );
      materials.forEach(material =>{
        cablesTypeFive.push(
          {
            id: material.sm_id,
            label: material.sm_short_description ? material.sm_short_description : material.sm_description
          }
        )
      });
      this.cableTypeFiveOptions = cablesTypeFive;
    },
    async getCableTypeSixOptions(){
      const cablesTypeSix = [];
      const materials = await this.fetchStockMaterialsList(
        {
          workspace_uuid: this.$store.getters.workspace.uuid,
          material_family_id: "ca",
          network_level_id: "6",
          append: "family_specific_fields"
        }
      );
      materials.forEach(material =>{
        cablesTypeSix.push(
          {
            id: material.sm_id,
            label: material.sm_short_description ? material.sm_short_description : material.sm_description
          }
        )
      });
      this.cableTypeSixOptions = cablesTypeSix;
    },
    getAllFractions(){
      let allFractions = [];
      if(!this.selectedObject.data){
        this.groundFloors.forEach(floor =>{
          floor.fractions.forEach(fraction =>{
              allFractions.push(fraction);
          })
        });
        this.undergroundFloors.forEach(floor =>{
            floor.fractions.forEach(fraction =>{
                allFractions.push(fraction);
            })
        });
      }else{
        allFractions = this.selectedObject.data;
      }
      return allFractions;
    },
    getFloorboxs(){
      let allFloorboxes = [];
      if(this.selectedObject.type === 'Column'){
        this.columns.forEach(column =>{
          column.floorboxes.forEach(floorbox =>{
            if(this.selectedObject.uuid === floorbox.column_uuid){
              allFloorboxes.push(floorbox);
            }
          })
        })
      }else if(this.selectedObject.type === 'Floor') {
        this.columns.forEach(column =>{
          column.floorboxes.forEach(floorbox =>{
            if(this.selectedObject.uuid === floorbox.floor_uuid){
              allFloorboxes.push(floorbox);
            }
          })
        })
      }
      return allFloorboxes;
    },
    /** Gets the list of colours */
    async getFloorboxColours() {
      let colours = await this.GET_LIST({ listName: "list_vert_planning_fbox_colors" });
      for (let i = 0; i < colours.length - 1; i++) {
        this.floorboxColors.push({
          id: colours[i].code,
          label: colours[i].libelle
        })
      }
    },
    /** Closes the building structure dialog */
    closeDialog() {
      this.dialogIsOpen = false;
    },
    openTecnicalLocalForm(){
      this.itemToEdit = null;
      this.tecnicalLocalFormIsOpen = true;
    },
    closeTecnicalLocalForm(){
      this.tecnicalLocalFormIsOpen = false;
    },
    addTecnicalLocal(obj){
      this.technicalLocals.push(obj);
      this.updateVerticalPlanningData();
    },
    editTecnicalLocal(item, index){
      const arrayCopy = [...this.technicalLocals];
      arrayCopy[index] = {...item};
      this.technicalLocals = arrayCopy; 
      this.updateVerticalPlanningData();
    },
    deleteTecnicalLocal(index){
      const technicalUuid = this.technicalLocals[index].uuid;
      this.technicalLocals.splice(index, 1);
      this.columns.forEach(column =>{
        column.floorboxes.forEach(floorbox =>{
          if(floorbox.technical_local_uuid === technicalUuid){
            floorbox.technical_local_uuid = null;
            floorbox.cable_in_length = null;
            floorbox.cable_in_owner_id = null;
            floorbox.cable_in_material_id = null;
          }
        })
      });
      this.updateVerticalPlanningData();
    },
    openEditTecnicalLocal(item, index){
      this.itemToEdit = {
        data: item,
        index
      };
      this.tecnicalLocalFormIsOpen = true;
    },
    /** Builds the building based on the input parameters, updates the data to send and closes the dialog */
    previewBuilding(data) {
      this.fractionsPerFloor = data.fractions;
      for (let i = 0; i < data.groundFloors; i++) {
        this.addFloor(i, 'ground')
      }
      for (let i = 0; i < data.undergroundFloors; i++) {
        this.addFloor(-1 - i, 'underground')
      }
      this.closeDialog();
      this.updateVerticalPlanningData();
      this.showTable = true;
    },

    /** Adds a column to the building and updates the data */
    addColumn() {
      if (this.columns.length < 10) {
        this.columns.push({
          floorboxes: [],
          index: this.columns.length + 1,
          uuid: uuidv4()
        })
        this.updateVerticalPlanningData();
      }
    },

    /** Adds a floor to the building and updates the data */
    addFloor(numberOfFloor, floorType) {
      let floor_uuid = uuidv4();
      let fractions = [];
      for (let i = 0; i < this.fractionsPerFloor; i++) {
        fractions.push({
          floorbox_uuid: null,
          floorbox_color: null,
          floorbox_label: null,
          address: null,
          classification_type: null,
          client_id: null,
          comment: null,
          contract_status: null,
          cable_in_material_id: null,
          cable_in_length: null,
          cable_in_owner_id: null,
          status: null,
          uuid: uuidv4(),
          floor_uuid: floor_uuid
        })
      }

      let floor = {
        index: numberOfFloor,
        fractions: fractions,
        uuid: floor_uuid
      }
      if (floorType === 'ground') {
        this.groundFloors.push(floor)
      } else if (floorType === 'underground') {
        this.undergroundFloors.push(floor)
      }

      this.updateVerticalPlanningData();
    },

    /**
     * Selects a fraction if no floorbox is selected.
     * If there is a selected floorbox and the fraction isn't connected to a floorbox, it gets connected to the selected floorbox.
     * Else, if the selected floorbox is the same as the floorbox connected to the selected fraction, the connection is removed.
     * Finally, the building key is incremented to force an update in the building component and the data is updated.
     *
     * @param floorIndex - the index of the floor of the selected fraction
     * @param floorType - the type of the floor of the selected fraction
     * @param fractionIndex - the index of the selected fraction
     *
     */
    selectFraction(floorIndex, floorType, fractionIndex) {
      if (this.selectedFloorbox.uuid) {
        if (floorType === 'g' && this.groundFloors[floorIndex].fractions[fractionIndex].floorbox_uuid !== this.selectedFloorbox.uuid) {
          this.groundFloors[floorIndex].fractions[fractionIndex].floorbox_uuid = this.selectedFloorbox.uuid;
          this.groundFloors[floorIndex].fractions[fractionIndex].floorbox_label = this.selectedFloorbox.label;
          this.groundFloors[floorIndex].fractions[fractionIndex].floorbox_color = this.selectedFloorbox.color;
          this.groundFloors[floorIndex].fractions[fractionIndex].closure_id = this.selectedFloorbox.id;
          this.groundFloors[floorIndex].fractions[fractionIndex].cable_in_material_id = this.selectedFloorbox.cable_out_material_id;
          this.groundFloors[floorIndex].fractions[fractionIndex].cable_in_owner_id = this.selectedFloorbox.cable_out_owner_id;
        } else if (floorType === 'u'  && this.undergroundFloors[floorIndex].fractions[fractionIndex].floorbox_uuid !== this.selectedFloorbox.uuid) {
          this.undergroundFloors[floorIndex].fractions[fractionIndex].floorbox_uuid = this.selectedFloorbox.uuid;
          this.undergroundFloors[floorIndex].fractions[fractionIndex].floorbox_label = this.selectedFloorbox.label;
          this.undergroundFloors[floorIndex].fractions[fractionIndex].floorbox_color = this.selectedFloorbox.color;
          this.undergroundFloors[floorIndex].fractions[fractionIndex].closure_id = this.selectedFloorbox.id;
          this.undergroundFloors[floorIndex].fractions[fractionIndex].cable_in_material_id = this.selectedFloorbox.cable_out_material_id;
          this.undergroundFloors[floorIndex].fractions[fractionIndex].cable_in_owner_id = this.selectedFloorbox.cable_out_owner_id;
        } else {
          this.clearFractionFloorboxConnection(floorIndex, fractionIndex, floorType)
        }
        this.buildingKey++;
        this.updateVerticalPlanningData();
      } else {
        this.selectFloor(floorIndex, floorType);
      }
    },

    /**
     * Clears the connection of the received fraction
     *
     * @param floorIndex - the index of the floor of the selected fraction
     * @param fractionIndex - the index of the selected fraction
     * @param floorType - the type of the floor of the selected fraction
     */
    clearFractionFloorboxConnection(floorIndex, fractionIndex, floorType) {
      if (floorType === 'g') {
        this.groundFloors[floorIndex].fractions[fractionIndex].floorbox_uuid = null;
        this.groundFloors[floorIndex].fractions[fractionIndex].floorbox_label = null;
        this.groundFloors[floorIndex].fractions[fractionIndex].floorbox_color = null;
        this.groundFloors[floorIndex].fractions[fractionIndex].cable_in_material_id = null;
        this.groundFloors[floorIndex].fractions[fractionIndex].cable_in_owner_id = null;
        this.groundFloors[floorIndex].fractions[fractionIndex].cable_in_length = null;
        if (this.groundFloors[floorIndex].fractions[fractionIndex].closure_id) this.groundFloors[floorIndex].fractions[fractionIndex].closure_id = null
      } else if (floorType === 'u') {
        this.undergroundFloors[floorIndex].fractions[fractionIndex].floorbox_uuid = null;
        this.undergroundFloors[floorIndex].fractions[fractionIndex].floorbox_label = null;
        this.undergroundFloors[floorIndex].fractions[fractionIndex].floorbox_color = null;
        this.undergroundFloors[floorIndex].fractions[fractionIndex].cable_in_material_id = null;
        this.undergroundFloors[floorIndex].fractions[fractionIndex].cable_in_owner_id = null;
        this.groundFloors[floorIndex].fractions[fractionIndex].cable_in_length = null;
        if (this.undergroundFloors[floorIndex].fractions[fractionIndex].closure_id) this.undergroundFloors[floorIndex].fractions[fractionIndex].closure_id = null
      }
    },

    /**
     * Puts the seleted floorbox on the top of its column
     *
     * @param columnIndex - index of the selected floorbox's column
     * @param floorboxIndex - index of the selected floorbox
     */
    swapFloorbox(columnIndex, floorboxIndex) {
      this.clearFloorbox();
      let swap = this.columns[columnIndex - 1].floorboxes.splice(floorboxIndex, 1);
      this.columns[columnIndex - 1].floorboxes.unshift(swap[0])
    },

    /**
     * Selects a column from the building.
     * If the current selected column is the same as the newly selected one, the data is cleared.
     *
     * @param columnIndex - index of the column
     */
    selectColumn(columnIndex) {
      if (this.selectedObject.index !== columnIndex || this.selectedObject.type != "Column") {
        this.selectedObject.data = this.columns[columnIndex - 1].floorboxes;
        this.selectedObject.type = "Column";
        this.selectedObject.index = columnIndex
        this.selectedObject.uuid = this.columns[columnIndex - 1].uuid
      } else {
        this.clearSelectedObject();
      }
    },

    /**
     * Selects a floor if the currently selected object is different from the newly selected floor.
     * If it's the same, the data is cleared.
     *
     * @param floorIndex - index of the selected floor
     * @param floorType - type of the selected floor
     */
    selectFloor(floorIndex, floorType) {
      if (floorType === 'g' && (floorIndex !== this.selectedObject.index || this.selectedObject.type != "Floor")) {
        this.selectedObject.index = floorIndex;
        this.selectedObject.data = this.groundFloors[floorIndex].fractions;
        this.selectedObject.uuid = this.groundFloors[floorIndex].uuid;
        this.selectedObject.type = "Floor";
      } else if (floorType === 'u' && ((-(floorIndex) -1) !== this.selectedObject.index || this.selectedObject.type != "Floor")) {
        this.selectedObject.index = -(floorIndex) -1;
        this.selectedObject.data = this.undergroundFloors[floorIndex].fractions;
        this.selectedObject.uuid = this.undergroundFloors[floorIndex].uuid;
        this.selectedObject.type = "Floor";
      } else {
        this.clearSelectedObject();
      }
    },

    /** Clears the selected object data */
    clearSelectedObject() {
      this.selectedObject.data = null;
      this.selectedObject.type = null;
      this.selectedObject.uuid = null;
      this.selectedObject.id = null;
      this.selectedObject.index = null;
    },

    /**
     * Selects a floorbox if it's different from the current one, else the data is cleaned
     *
     * @param floorbox - the selected floorbox data
     */
    selectFloorbox(floorbox) {
      if (floorbox.label !== this.selectedFloorbox.label) {
        this.selectedFloorbox.id = floorbox.id;
        this.selectedFloorbox.label = floorbox.label;
        this.selectedFloorbox.color = floorbox.color;
        this.selectedFloorbox.uuid = floorbox.uuid;
        this.selectedFloorbox.cable_out_material_id = floorbox.cable_out_material_id;
        this.selectedFloorbox.cable_out_owner_id = floorbox.cable_out_owner_id;
      } else {
        this.clearFloorbox();
      }
    },

    /** Clears the floorbox data */
    clearFloorbox() {
      this.selectedFloorbox.id = null;
      this.selectedFloorbox.color = null;
      this.selectedFloorbox.label = null;
      this.selectedFloorbox.uuid = null;
    },

    /**
     * Connects all the fractions of a floor to the selected floorbox, increments the building key and updates the data
     *
     * @param floorIndex - index of the selected floor
     * @param floorType - type of the selected floor
     */
    connectAllFractions(floorIndex, floorType) {
      if (floorType === 'g') {
        this.groundFloors[floorIndex].fractions.forEach(fraction => {
          fraction.floorbox_uuid = this.selectedFloorbox.uuid;
          fraction.floorbox_label = this.selectedFloorbox.label;
          fraction.floorbox_color = this.selectedFloorbox.color;
          fraction.cable_in_material_id = this.selectedFloorbox.cable_out_material_id;
          fraction.cable_in_owner_id = this.selectedFloorbox.cable_out_owner_id;
        });
      }else if (floorType === 'u') {
        this.undergroundFloors[floorIndex].fractions.forEach(fraction => {
          fraction.floorbox_uuid = this.selectedFloorbox.uuid;
          fraction.floorbox_label = this.selectedFloorbox.label;
          fraction.floorbox_color = this.selectedFloorbox.color;
          fraction.cable_in_material_id = this.selectedFloorbox.cable_out_material_id;
          fraction.cable_in_owner_id = this.selectedFloorbox.cable_out_owner_id;
        });
      }
      this.buildingKey++;
      this.updateVerticalPlanningData();
    },
    //receives object with floor uuid and fraction uuid
    deleteFloorFraction(obj) {
      const floor_index = this.getFloorIndex(obj.floor_uuid, this.groundFloors, this.undergroundFloors);
      if (floor_index >= 0) {
        let fractionIndex = this.groundFloors[floor_index].fractions.findIndex(fraction => fraction.uuid === obj.fraction_uuid);
        const groundFloorsArray = [];
        this.groundFloors.forEach(floor =>{
          groundFloorsArray.push(floor);
        });
        groundFloorsArray[floor_index].fractions.splice(fractionIndex, 1);
        //have to do this so vue can detect changes on array and update table
        this.groundFloors = groundFloorsArray;
      } else {
        let fractionIndex = this.undergroundFloors[-floor_index -1].fractions.findIndex(fraction => fraction.uuid === obj.fraction_uuid);
        const undergroundFloorsArray = [];
        this.undergroundFloors.forEach(floor =>{
          undergroundFloorsArray.push(floor);
        });
        undergroundFloorsArray[-floor_index -1].fractions.splice(fractionIndex, 1);
        //have to do this so vue can detect changes on array and update table
        this.undergroundFloors = undergroundFloorsArray;
      }
      this.updateVerticalPlanningData();
    },

    /**
     * Deletes a column, updates the data and clears the selected object and floorbox data
     *
     * @param columnIndex - index of the column
     */
    deleteColumn(columnIndex) {
      let floors = this.groundFloors.concat(this.undergroundFloors);
      floors.forEach(floor => {
        floor.fractions.forEach(fraction => {
          let connectedFloorboxIdBelongsToColumn = this.columns[columnIndex - 1].floorboxes.filter(floorbox => {
            const hasClosure = floorbox.hasOwnProperty('closure');
            const floorboxUuid = hasClosure ? floorbox.closure.cl_uuid : floorbox.uuid
            return floorboxUuid === fraction.floorbox_uuid
          })
          if (connectedFloorboxIdBelongsToColumn.length > 0) {
            fraction.floorbox_uuid = null;
            fraction.floorbox_label = null;
            fraction.floorbox_color = null;
            fraction.cable_in_material_id = null;
            fraction.cable_in_owner_id = null;
            fraction.cable_in_length = null;
            if (fraction.closure_id) fraction.closure_id = null;
          }
        })
      })
      this.columns.splice(columnIndex - 1, 1);
      this.columns.forEach(column => {
        if (column.index > columnIndex) {
          column.index--;
        }
      });
      this.updateVerticalPlanningData();
      this.clearSelectedObject();
      this.clearFloorbox();
    },

    /**
     * Deletes a floor, updates the data and clears the selected object data
     *
     * @param floorIndex - index of the floor to delete
     */
    deleteFloor(floorIndex) {
      if (floorIndex < 0) {
        this.undergroundFloors.splice(-floorIndex -1, 1)
      } else {
        this.groundFloors.splice(floorIndex, 1);
      }
      this.updateVerticalPlanningData();
      this.clearSelectedObject();
    },

    /**
     * Deletes a floorbox  and cleares the selected floorbox data
     *
     * @param columnUuid - uuid of the floorbox's column
     * @param floorboxLabel - label of the floorbox to delete
     */
    deleteFloorbox(columnUuid, floorboxLabel) {
      const columnIndex = this.getColumnIndex(columnUuid, this.columns);
      let floors = this.groundFloors.concat(this.undergroundFloors);
      let floorboxIndex = this.columns[columnIndex - 1].floorboxes.findIndex(fl => fl.label === floorboxLabel)
      floors.forEach(floor => {
        floor.fractions.forEach(fraction => {
          if (floorboxLabel === fraction.floorbox_label ) {
            fraction.floorbox_uuid = null;
            fraction.floorbox_label = null;
            fraction.floorbox_color = null;
            fraction.cable_in_material_id = null;
            fraction.cable_in_owner_id = null;
            fraction.cable_in_length = null;
            if (fraction.closure_id) fraction.closure_id = null;
          }
        })
      })
      this.columns[columnIndex - 1].floorboxes.splice(floorboxIndex, 1);
      this.updateVerticalPlanningData();
      this.clearFloorbox();
    },
    /**
     * Selects an item of the data table
     *
     * @param floorIndex - index of the floor of the fraction to select
     * @param floorType - type of the floor of the fraction to select
     * @param fractionIndex - index of the fraction to select
     */
    selectTableItem(floorIndex, floorType, fractionIndex) {
      if (this.selectedFloorbox.id) {
        this.selectFraction(floorIndex, floorType, fractionIndex);
      }
    },

    /**
     * Creates a fraction in the building
     *
     * @param objectData - data of the fraction to create
     */
    createFraction(objectData) {
      const floor_index = this.getFloorIndex(objectData.floor_uuid, this.groundFloors, this.undergroundFloors);
      if (floor_index < 0 ) {
        const undergroundFloorsArray = [];
        this.undergroundFloors.forEach(floor =>{
          undergroundFloorsArray.push(floor);
        });
        undergroundFloorsArray[-floor_index -1].fractions.push(objectData);
        // need to do this so vue can detect changes on array
        this.undergroundFloors = undergroundFloorsArray;
      } else if (floor_index >= 0) {
        const groundFloorsArray = [];
        this.groundFloors.forEach(floor =>{
          groundFloorsArray.push(floor);
        });
        groundFloorsArray[floor_index].fractions.push(objectData);
        // need to do this so vue can detect changes on array
        this.groundFloors = groundFloorsArray;
      }
      this.updateVerticalPlanningData();
    },
    /**
     * Creates a floorbox, as long as the selected floor exists and the label and color are unique
     *
     * @param objectData - data of the object to create
     */
    createFloorbox(objectData) {
      const columnIndex = this.getColumnIndex(objectData.column_uuid, this.columns);
      if (this.floorboxLabelAndColorAreUnique(objectData.label, objectData.color, 'create')) {
        this.columns[columnIndex - 1].floorboxes.push(objectData);
        this.updateVerticalPlanningData();
      } else {
        this.$toasted.global.toast_error("The color or the label already exist")
      }
    },

    /**
     * Save the edited fraction and updates the key of the building to force the refresh of the building component.
     *
     * @param data - the edited fraction data
     * @param index - the edited fraction index
     */
    saveFraction(fraction) {
      const floor_index = this.getFloorIndex(fraction.floor_uuid, this.groundFloors, this.undergroundFloors);
      if (floor_index < 0 ) {
        const fractionIndex = this.undergroundFloors[-floor_index -1].fractions.map(fraction => fraction.uuid).indexOf(fraction.uuid);
        this.undergroundFloors[-floor_index -1].fractions[fractionIndex] = fraction;
      } else {
        const fractionIndex = this.groundFloors[floor_index].fractions.map(fraction => fraction.uuid).indexOf(fraction.uuid);
        this.groundFloors[floor_index].fractions[fractionIndex] = fraction;
      }
      this.buildingKey++;
      this.updateVerticalPlanningData();
    },

    /**
     * Saves an edited floorbox, as long as the floor exists and the label and color are unique, and updates the building key.
     *
     * @param data - the edited floorbox data
     * @param index - the edited floorbox index
     */
    saveFloorbox(data, index) {
      const columnIndex = this.getColumnIndex(data.column_uuid, this.columns);
      if (this.floorboxLabelAndColorAreUnique(data.label, data.color, 'edit')) {
        if (this.selectedFloorbox.label === this.columns[columnIndex  - 1].floorboxes[index].label) {
          this.selectedFloorbox.color = data.color;
          this.selectedFloorbox.label = data.label;
        }

        let floors = this.groundFloors.concat(this.undergroundFloors);
        floors.forEach(floor => {
          floor.fractions.forEach(fraction => {
            const isClosure = this.columns[columnIndex - 1].floorboxes[index].hasOwnProperty('closure');
            const floorboxId = isClosure ? this.columns[columnIndex - 1].floorboxes[index].closure.cl_uuid : this.columns[columnIndex - 1].floorboxes[index].uuid
            if (fraction.floorbox_uuid === floorboxId) {
              fraction.floorbox_uuid = data.uuid;
              fraction.floorbox_label = data.label;
              fraction.floorbox_color = data.color;
            }
          });
        });
        this.columns[columnIndex - 1].floorboxes[index] = data;
        this.buildingKey++;
        this.updateVerticalPlanningData();
      } else {
        this.$toasted.global.toast_error("The color or the label already exist")
      }
    },

    /**
     * Checks if the label and color of a floorbox are unique.
     *
     * @param label - label to be checked
     * @param color - color to be checked
     * @param action - the action the user is performing (edit, create, view)
     *
     * @return {Boolean} a boolean indicating if the label and color are unique
     */
    floorboxLabelAndColorAreUnique(label, color, action) {
      let paramsAreUnique = true;
      this.columns.forEach(column => {
        let filteredFloorboxes = column.floorboxes.filter(floorbox => floorbox.label === label || floorbox.color === color);
        if ((filteredFloorboxes.length > 1 && action === 'edit') || (filteredFloorboxes.length > 0 && action === 'create')) {
          paramsAreUnique = false;
          return;
        }
      });
      return paramsAreUnique;
    },

    /**
     * Checks if the floor number exists
     *
     * @param floor - the floor to check
     *
     * @return {Boolean} a boolean indicating if the floor exists or not
     */
    floorExists(floor) {
      return floor < 0 ? this.undergroundFloors.length >= -(floor) : this.groundFloors.length > floor;
    },

    /**
     * Gets the floor uuid
     *
     * @param floor - the floor to retrieve the uuid from
     *
     * @return {String} the floor uuid
     */
    getFloorUuid(floor) {
      return floor < 0 ? this.undergroundFloors[-floor -1].uuid : this.groundFloors[floor].uuid
    },

    /**
     * Emits an event to update the vertical planning data in the parent component
     */
    updateVerticalPlanningData() {
      this.$emit("update-vertical-planning", {
        columns: this.columns,
        groundFloors: this.groundFloors,
        undergroundFloors: this.undergroundFloors,
        technicalLocals: this.technicalLocals
      })
    }
  }
}
</script>

<style scoped>
.form {
  display: flex;
  flex-direction: row;
}

.structure-button {
  background-color: var(--primary-highlight) !important;
  color: white !important;
}

.vertical-splitter {
  min-width: 1px;
  margin: 0 10px;
  max-height: 500px;
}
</style>



// WEBPACK FOOTER //
// src/components/Home/Forms/_SpecialTabs/Buildings/Vertical/VerticalPlanning.vue